import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import productData from "../data/productData";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function ProductsSection() {
    const { t } = useTranslation();
    useScrollAnimation();
    const showData = productData.slice(0, 3).map((el, index) =>
        <div key={index} className="w-100 js-scroll fade-btm w-[32%] rounded-[8px] shadow-md shadow-[#00000024]">
            <div className="w-[100%] h-[260px]">
                <img className="w-full h-full rounded-t-[8px]" src={el.image} alt={el.title} />
            </div>
            <div className="p-[20px] flex flex-col gap-[25px] justify-between">
                <div className="flex flex-col gap-[5px]">
                    <div className="text-[20px] text-[#017E89] font-bold">{el.title}</div>
                    <p className="text-[13px]">{el.description.length > 50 ? `${el.description.substring(0, 100)}...` : el.description}</p>
                </div>
                <Link to={`/productsDetails/${el.id}`}>
                    <span className="capitalize font-bold">More Details</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col items-center justify-center mx-auto w-fit">
                <div className="js-scroll fade-top w-[90px] h-[30px]">
                    <img className="w-[100%] h-[100%]" src={require("../../assets/icons/lineMainTitle.svg").default} alt="" />
                </div>
                <div className="js-scroll fade-btm text-[35px] font-bold uppercase text-[#017E89]">{t("Products")}</div>
                <span className="js-scroll fade-btm w-[50%] bg-[#017E89] h-[3px]"></span>
            </div>
            <div className="container flex flex-col gap-[15px] items-center py-[20px]">
                <div className="f-fol flex gap-[10px] flex-wrap ">
                    {showData}
                </div>
                <Link className="js-scroll fade-btm bg-[#017E89] w-fit px-[30px] py-[7px] rounded-[4px] text-white font-bold capitalize" to={"/product"}>{t("Show More")}</Link>
            </div>
        </section>
    );
}